import React, { useState } from 'react';
import { useHistory,withRouter,useNavigate } from 'react-router-dom';
import { surveyRegisterSave } from "../service/UserDetails";
import UserService from '../service/UserService';
import { Divider } from 'antd';

import {
  AutoComplete,
  Button,
  Cascader,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,Space,notification
} from 'antd';

const { Option } = Select;
const formItemLayout = {
  
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const UserRegisteration = () => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    
  };
const [registerUser, setRegisterUser] = useState({
    name: "",
    username: "",
    password: "",
    password_confirmation: "",
    role: "",
});
const [msg, setMsg] = useState("")

// const handleChange = (e) => {
//     const value = e.target.value;
//     setRegisterUser({ ...registerUser, [e.target.name]: value })
// }


  const [name ,setName] = useState('')
  const [username ,setUsername] = useState('')
  const [password ,setPassword] = useState('')
  const [password_confirmation ,setConfirm] = useState('')
  //const [token, setToken] = useState(null);
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  
  const handleOnChange = (event) => {
    const value = event.target.value;
    setRole(value);
    
    //form.setFieldValue('product_id',1);
    
  }

  function registerUserAdded (e){
   // e.preventDefault();
    const registerUser = {name,username, password,password_confirmation,role};
    // 
    // const payload = registerUser 
    
   // surveyRegisterSave(user);
   // 
   UserService.saveRegister(registerUser)
            .then((res) => {
                notification.success({message:"User Successfully Registered !"});
                form.resetFields();
                
                setMsg("Used Added Sucessfully");
                
                const data = res.data
              //  setToken(data.data.token);
                setRole(data.data.user.role);
               
            }).catch((error) => {
                console.log({
                    error, 
                    'error status': error.response.status, 
                    'error response': error.response.data
                  })
                  notification.error({message:"Registration failed !"});
            });

  //  navigator('/search-page')
}
  const [autoCompleteResult, setAutoCompleteResult] = useState([]);
  
  return (
    
    <div style={{marginLeft:220,marginTop:'50px',borderColor:'#7cb305'}}> 
    {/* <Divider variant="dotted" style={{width:'50%',borderColor: '#7cb305' }}>User Registration</Divider> */}

   
    <Form
      {...formItemLayout}
      form={form}
     // className="login-form"
      name="register"
      onFinish={registerUserAdded}
    //  onSubmit={(e) => RegisterUser(e)}
      style={{
        maxWidth: 600,
      }}
      scrollToFirstError
    >
         <Form.Item
        name="name"
        label="Name"
        rules={[
          {
            required: true,
            message: 'Please input your name!',
          },
        ]}
      >
        <Input style={{borderColor:'#7cb305'}} onChange={e => setName(e.target.value)}  />
      </Form.Item>
      <Form.Item
        name="username"
        label="Username"
        rules={[
          
          {
            required: true,
            message: 'Please enter username!',
          },
        ]}
      >
        <Input style={{borderColor:'#7cb305'}} onChange={e => setUsername(e.target.value)}/>
      </Form.Item>

      <Form.Item
        name="password"
        label="Password"
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
        ]}
        
      >
        <Input.Password style={{borderColor:'#7cb305'}} onChange={e => setPassword(e.target.value)}/>
      </Form.Item>

      <Form.Item
        name="password_confirmation"
        label="Confirm Password"
        
        dependencies={['password']}
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Please confirm your password!',
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('The new password that you entered do not match!'));
            },
          }),
        ]}
      >
        <Input.Password 
        style={{borderColor:'#7cb305'}}
        onChange={e => setConfirm(e.target.value)}/>
      </Form.Item>

      <Form.Item
        name="role"
        label="Role"
        
      >
        {/* <Select defaultValue="test" onChange={e => setRole(Select.Option.value)}>
        <Select.Option value="Admin">Admin</Select.Option> 
        <Select.Option value="Survey">Survey</Select.Option> 
        <Select.Option value="Sales">Sales</Select.Option> 
        <Select.Option value="Quality">Quality</Select.Option> 
        </Select> */}

      <select style={{ width: 200,height:28 }} 
      //value={role} 
      onChange={handleOnChange} 
    >
      <option defaultValue>Select User</option>
      <option value="admin">Admin</option>
      <option value="survey">Survey</option>
      <option value="sales">Sales</option>
      <option value="quality">Quality</option>
    </select>
    {/*   {role && <h2 className="mt-3">{role}</h2>} */}
        {/* <Input onChange={e => setRole(e.target.value)}/> */}
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
      <button class="button-demo" role="button">Register</button>
        {/* <Button type="primary" htmlType="submit">Register</Button> */}
      </Form.Item>
    </Form></div>
  );
};
export default UserRegisteration;